<template>
  <div>
    <!-- 收件 -->
    <baseBreadcrumb :page="$t('message.signer')" :menu="$t('message.scanningParcel')" />
    <div class="body">
      <div class="num">
        <span>今日拆包数{{ numData.unpack_num }}</span>
        <span>今日签收数{{ numData.receive_num }}</span>
      </div>
      <div class="search">
        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="data.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="data.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--  客户属性-->
        <div class="item select">
          <el-select v-model="data.attribute" placeholder="客户属性">
            <el-option v-for="item in vipList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!--人员范围-->
        <div class="item">
          <!--  人员范围-->
          <cascader @setUserList="setUserList" :org_id="data.org_id" ref="cascader" />
        </div>
        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="data.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!--  搜索type-->
        <div class="item select">
          <el-select v-model="data.type" placeholder="状态">
            <el-option v-for="item in receiveStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 请输入快递单号 -->
        <div class="item">
          <input type="text" v-model="data.express_no" onfocus="this.select()"
            :placeholder="$t('message.pleaseEnterTheTrackingNumber')" @keyup.enter="receiveStore" class="input">
          <!-- <el-input :placeholder="$t('message.pleaseEnterTheTrackingNumber')" v-model="data.express_no"
            onfocus="this.select()" clearable @change="receiveStore">
          </el-input> -->
        </div>

        <!-- 按钮 -->
        <div class="item">
          <el-button type="primary" class="entry" @click="receiveStore" v-if="isAuth(292)">{{
            $t("message.entry")
          }}</el-button>
          <!-- 按钮 -->
          <el-button type="primary" @click="search" class="primary">{{
            $t("message.inquire")
          }}</el-button>
        </div>

      </div>
      <div class="search">


        <!--  搜索type-->
        <div class="item select">
          <el-select v-model="optionVal" placeholder="订单号后5位">
            <el-option v-for="item in optionType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="item">
          <el-input v-model="val" clearable onfocus="this.select()"> </el-input>
        </div>
        <!-- 包裹搜索 -->
        <el-button type="primary" @click="receivePackageInfo">{{
          $t("message.parcelSearch")
        }}</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>

          <!--  签收时间-->
          <el-table-column align="center" :label="$t('message.signForTime')" prop="created_at" width="150px">
          </el-table-column>

          <!--  类别-->
          <el-table-column align="center" :label="$t('message.category')" prop="type_name" width="110px">
          </el-table-column>
          <!--  物流号-->
          <el-table-column align="center" :label="$t('message.logisticsNumber')" prop="express_no">
          </el-table-column>
          <!--  订单号-->
          <el-table-column align="center" :label="$t('message.orderNumber')" prop="express_no">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.order_purchase_express" :key="index">
                <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_purchase.order_sn" target="_blank"
                  style="color:#b4272d">{{
                    item.order_purchase.order_sn }}</router-link> <br />
                {{ item.order_purchase.user.realname }}
              </p>
            </template>
          </el-table-column>
          <!-- 交易号 -->
          <el-table-column align="center" :label="$t('message.transactionNumber')" prop="purchase_no">

            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.order_purchase_express" :key="index">
                {{ item.order_purchase.purchase_no }}
              </p>
            </template>
          </el-table-column>

          <!--  收件人-->
          <el-table-column align="center" :label="$t('message.recipients')" prop="created_by_name" width="150px">

            <template slot-scope="scope">
              {{ scope.row.created_by_name }}
            </template>
          </el-table-column>
          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="150px">

            <template slot-scope="scope">
              <!-- 关联交易号 -->
              <p>
                <el-button size="small" type="success" @click="relatedTransactionNumber(scope.row)"
                  v-if="isAuth(294)">{{
                    $t("message.relatedTransactionNumber") }}</el-button>
              </p>

              <!-- 打印唛头 -->
              <p>
                <el-button size="small" type="primary" class="primary" @click="printingMarks(scope.row)">{{
                  $t("message.printingMarks") }}</el-button>
              </p>
            </template>
          </el-table-column>
          <!--  签收员备注-->
          <el-table-column align="center" :label="$t('message.remarksOfSigner')" width="160px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" type="textarea" @blur="updateReceiveRemark(scope.row)" :rows="3">
              </el-input>
            </template>
          </el-table-column>
          <!-- 签收备注图片 -->
          <el-table-column align="center" :label="$t('message.signAndNoteThePicture')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="scope.row.remark_image" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference" @click="id = scope.row.id">
                  <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                    :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <el-image :src="scope.row.remark_image" style="width: 60px; height: 60px; border-radius: 4px">
                      <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </el-upload>
                </a>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!--  包裹搜索表单 -->
    <parcelSearchForm v-if="parcelSearchFormDialogVisible" :parcelSearchForm="parcelSearchForm" />
    <!-- 关联交易号 -->
    <relatedTransactionNumber v-if="relatedTransactionNumberDialogVisible" :express_no="express_no" />
    <!-- 收货-打印包裹信息  -->
    <div v-show="false">
      <PrintparcelinformationReceive ref="PrintparcelinformationReceive" v-if="show" :datas="printData" />
    </div>

    <audio src="../../../../assets/MP3/error.mp3" ref="error"></audio>
    <audio src="../../../../assets/MP3/no_stock.mp3" ref="no_stock"></audio>
    <audio src="../../../../assets/MP3/reject.mp3" ref="reject"></audio>
    <audio src="../../../../assets/MP3/system_success.mp3" ref="system"></audio>
    <audio src="../../../../assets/MP3/template_success.mp3" ref="template_success"></audio>
    <audio src="../../../../assets/MP3/urgent.mp3" ref="urgent"></audio>
    <!-- SVIP -->
    <audio src="../../../../assets/MP3/SVIP.mp3" ref="SVIP"></audio>
    <!-- 定额 -->
    <audio src="../../../../assets/MP3/quota.mp3" ref="quota"></audio>
    <!-- 潜力 -->
    <audio src="../../../../assets/MP3/potential.mp3" ref="potential"></audio>
  </div>
</template>

<script>
import { optionType, receiveStatus } from "@/utlis/options";
import parcelSearchForm from "../components/parcelSearchForm";
import relatedTransactionNumber from "../components/relatedTransactionNumber";
import PrintparcelinformationReceive from '@/components/Printedsheet/PrintparcelinformationReceive'
import { vipList } from '@/utlis//options'
export default {
  data() {
    return {
      vipList,
      tableData: [{}],
      id: 0, // 修改ID
      data: {
        page: 1,
        pageSize: 10,
        type: "",
        express_no: "",
        org_id: '',
        p_id: '',
      },

      total: 0,
      //   包裹详情
      receiveStatus,
      val: "",
      optionVal: "",
      optionType,
      parcelSearchFormDialogVisible: false,
      parcelSearchForm: [],
      //   关联交易号
      relatedTransactionNumberDialogVisible: false,
      express_no: "",
      // 打印数据
      printData: {},
      show: false,
      numData: {},//统计今日数量

    };
  },
  components: {
    parcelSearchForm,
    relatedTransactionNumber,
    PrintparcelinformationReceive
  },
  computed: {

    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.receiveList();
  },
  methods: {
    receiveList() {
      this.$api.signInApi.receiveList(this.data).then((res) => {
        this.tableData = res.data.data;
        this.tableData.forEach((list) => {
          // 数组去重
          var hash = {};
          list.order_purchase_express = list.order_purchase_express.reduce(function (item, next) {
            hash[next.express_no]
              ? ""
              : (hash[next.express_no] = true && item.push(next));

            return item;
          }, []);
        });
        this.total = res.data.total;
        this.receiveAndUnpackNum()

      });
    },
    //获取本部门今日收包裹与拆包裹数
    receiveAndUnpackNum() {
      this.$api.signInApi.receiveAndUnpackNum().then((res) => {
        this.numData = res.data

      })
    },
    // 收货-扫描签收
    receiveStore() {
      let express_no = this.data.express_no
      this.data.express_no = ''
      this.$api.signInApi.receiveStore({ express_no }).then((res) => {
        let type = res.data.type


        // this.$refs[type].play(); //播放
        // 付费会员
        if (res.data.vipType.id == 1) {
          this.$refs.quota.play(); //播放
          setTimeout(() => {
            this.$refs[type].play(); //播放
          }, 1500)
        } else if (res.data.vipType.id == 3) {// 潜力客户
          this.$refs.potential.play(); //播放
          setTimeout(() => {
            this.$refs[type].play(); //播放
          }, 1500)
        } else if (res.data.vipType.id == 2) {  // SVIP
          this.$refs.SVIP.play(); //播放
          setTimeout(() => {
            this.$refs[type].play(); //播放
          }, 1500)
        } else {
          // 播放音效
          this.$refs[type].play(); //播放
        }

        if (res.data.remark) {
          this.$alert(res.data.realname + ':' + res.data.remark, '提示', {
            confirmButtonText: '确定',
            center: true,
            callback: action => {
            }
          });
        }
        this.$forceUpdate()
        // this.receiveList();
      });
    },

    // 搜索
    search() {
      this.data.page = 1;
      this.receiveList();
    },
    // 重置
    reset() {
      this.data = {
        page: 1,
        pageSize: 10,
        type: "",
        express_no: "",
        attribute: '',
      };
      this.receiveList();
    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.receiveList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.receiveList();
    },
    //打印唛头
    printingMarks(row) {
      this.$api.signInApi.expressPackageInfo({ express_no: row.express_no }).then(res => {
        this.printData = res.data
        this.show = true
        this.$forceUpdate()
        this.$nextTick(() => {
          this.$print(this.$refs.PrintparcelinformationReceive);
        });
      })
    },
    //修改备注
    updateReceiveRemark(item) {
      let datas = {
        id: item.id,
        remark: item.remark,
      };
      this.$api.signInApi.updateReceiveRemark(datas).then((res) => {
        this.$message.success(res.msg);
      });
    },
    // 更改签收图片
    handleAvatarSuccess(res) {
      let datas = {
        id: this.id,
        remark_image: res.data,
      };
      this.$api.signInApi.updateReceiveRemarkImage(datas).then((res) => {
        this.$message.success(res.msg);
        this.receiveList();
      });
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    // 包裹搜索
    receivePackageInfo() {
      let searchData = {
        orderSnSuffix: "",
        orderSn: "",
        purchase_sn: "",
        express_no: "",
      };
      if (this.optionVal == 1) {
        searchData.orderSnSuffix = this.val;
      } else if (this.optionVal == 2) {
        searchData.orderSn = this.val;
      } else if (this.optionVal == 3) {
        searchData.purchase_sn = this.val;
      } else if (this.optionVal == 4) {
        searchData.express_no = this.val;
      }
      this.$api.signInApi.receivePackageInfo(searchData).then((res) => {
        if (res.data == false)
          return this.$message.error(
            this.$t("message.noCorrespondingOrderDetailsFound")
          );
        this.parcelSearchForm = res.data;
        this.parcelSearchFormDialogVisible = true;
      });
    },
    //关联交易号
    relatedTransactionNumber(item) {
      this.express_no = item.express_no;
      this.relatedTransactionNumberDialogVisible = true;
    },
    // 人员范围
    setUserList(data) {

      this.data.org_id = data.id;

    },
  },
};
</script>

<style lang='scss' scoped>
.body {
  position: relative;

  .num {
    position: absolute;
    top: -60px;
    left: 300px;
    font-size: 20px;
    color: #B4272D;
    line-height: 40px;
    font-weight: 600;

    span {
      margin-right: 150px;
    }
  }
}

.search {
  margin-bottom: 24px;
  display: flex;
  position: relative;

  .entry {
    background-color: #ffa21d;
    border-color: #ffa21d;
  }

  .item {
    width: 220px;
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }

  .select {
    width: 140px;
  }

  .add {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
      text-align: center;
      padding: 9px 0;
    }
  }
}

.content {
  padding: 0 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}

.input {
  width: 200px;
  height: 38px;
  border: 1px solid #DCDFE6;
  border-radius: 6px;
  padding: 0 10px;
}
</style>